<template>
  <!--    //@ ts-ignore-->
  <div class="row">
    <OrderInfoItemWrapperComponent :data-class-name="'__data-1'"
                                   :translate-key="'drive_from'">
      <template #icon-item>
        <img src="/assets/images/Framelocation-icon.png" alt="location">
      </template>
      <template #order-info>
        {{orderData.pickUp.address_to_show}}, {{ orderData.pickUp.city }} {{ (orderData.pickup_specified_address.length > 0) ? `(${orderData.pickup_specified_address})` : '' }}
      </template>
    </OrderInfoItemWrapperComponent>

    <OrderInfoItemWrapperComponent :data-class-name="'__data-2'"
                                   :translate-key="'departure'">
      <template #icon-item>
        <img src="/assets/images/Framecalendar-icon.png" alt="pickup-date-time">
      </template>
      <template #order-info>
        {{ tripDepartureDate }} {{ tripDepartureTime }}
      </template>
    </OrderInfoItemWrapperComponent>

    <OrderInfoItemWrapperComponent
        :data-class-name="'__data-3'"
        :translate-key="'stops'" data-bs-toggle="modal" :data-bs-target="`#transportation-route-map-${orderData.transportationId}`">
      <template #icon-item>
          <img id="open-trip-map" src="/assets/images/plus-circle-plus-svg.svg" alt="end-date-time" @mouseover="onHover($event)" @mouseout="onUnHover($event)">
      </template>
      <template #order-info>
        {{stopCount}}
      </template>
    </OrderInfoItemWrapperComponent>

    <OrderInfoItemWrapperComponent :data-class-name="'__data-4'"
                                   :translate-key="'arrival'">
      <template #icon-item>
        <img src="/assets/images/Framecalendar-icon.png" alt="end-date-time">
      </template>
      <template #order-info>
        {{ tripDepartureDate }} {{ tripArrivalTime }}
      </template>
    </OrderInfoItemWrapperComponent>

    <OrderInfoItemWrapperComponent :data-class-name="'__data-5'"
                                   :translate-key="'drive_to'">
      <template #icon-item>
        <img src="/assets/images/Framedestination.png" alt="end-date-time">
      </template>
      <template #order-info>
        {{orderData.dropOff.address_to_show}}, {{ orderData.dropOff.city }} {{ (orderData.dropoff_specified_address.length > 0) ? `(${orderData.dropoff_specified_address})` : '' }}
      </template>
    </OrderInfoItemWrapperComponent>

    <OrderInfoItemWrapperComponent :data-class-name="'__data-6'"
                                   :translate-key="'passengers'">
      <template #icon-item>
        <img src="/assets/images/Framepeople-icon.png" alt="people-count">
      </template>
      <template #order-info>
        {{ orderData.tripPassengers }}
      </template>
    </OrderInfoItemWrapperComponent>
  </div>

  <ModalComponent :show-title="false" :id-data="`transportation-route-map-${orderData.transportationId}`">
    <template #body-content>
      <TransportationStopsModalContentComponent :data="selectedTrip"/>
    </template>
  </ModalComponent>
  <div class="col-sm-12 col-md-12 col-lg-11 hr-line"></div>
</template>

<script lang="ts">
import {defineComponent} from "vue";
// @ts-ignore
import OrderInfoItemWrapperComponent from "../../orderInfoItemWrapper/OrderInfoItemWrapperComponent.vue";
// @ts-ignore
import TransportationStopsModalContentComponent from "../../../transportationStopsModalContent/TransportationStopsModalContentComponent.vue";
// @ts-ignore
import ModalComponent from "../../../modal/ModalComponent.vue";
import type {IApiResponseTransportation} from "@/interfaces/apiResponseInterfaces/IApiResponseTransportation.interface";
import {dateHelpers} from "../../../../helpers/dateHelpers";

export default defineComponent({
  name: 'RoundTripFalseWrapperComponent',
  components: {
    ModalComponent,
    TransportationStopsModalContentComponent,
    OrderInfoItemWrapperComponent
  },
  props: {
    orderData: {
      type: Object
    }
  },
  data() {
    return {
      isOpen: false
    }
  },

  computed: {
    stopCount(): number {
      return this.orderData!.transportations
          .find(trip => trip.id === this.orderData!.transportationId).transportation_stop.length;
    },

    selectedTrip(): IApiResponseTransportation {
      return this.orderData!.transportations
          .find(trip => trip.id === this.orderData!.transportationId);
    },

    tripDepartureDate(): string {
      return dateHelpers.dateToDisplay(this.orderData!.tripDepartureDate);
    },
    allAddresses(): {id: number, time: string, city: string}[] {
      const allAddresses = this.orderData!.transportations.find(trip => trip.id === this.orderData!.transportationId);

      return [
        {
          id: allAddresses.pickup_city.id,
          time: allAddresses.pickup_time,
          city: allAddresses.pickup_city.address_to_show
        },
          ...allAddresses.transportation_stop.map(stop => {
            return {
              id: stop.transportation_address.id,
              time: stop.time,
              city: stop.transportation_address.address_to_show
            }
          }),
        {
          id: allAddresses.dropoff_city.id,
          time: allAddresses.drop_off_time,
          city: allAddresses.dropoff_city.address_to_show
        }
      ];
    },
    tripDepartureTime(): string {
      return this.allAddresses.find(el => el.id === this.orderData!.pickUp.id)!.time;
    },
    tripArrivalTime(): string {
      return this.allAddresses.find(el => el.id === this.orderData!.dropOff.id)!.time;
    }
  },

  methods: {
    onHover($event: MouseEvent): void {
      ($event.target! as HTMLElement).setAttribute('src','images/plus-circle-plus-svg-blue.svg');
    },
    onUnHover($event: MouseEvent): void {
      ($event.target! as HTMLElement).setAttribute('src','images/plus-circle-plus-svg.svg');
    },
  }

})
</script>

<style scoped lang="scss">
</style>